import { useSelector } from 'react-redux';
import { licenseSelector } from 'state/selectors/license';
import styled from 'styled-components';
import { SIZES } from 'common/constants/sizes';
import { Link } from '@material-ui/core';
import { openSupportRequest } from 'common/services/zendesk.service';

const StyledMaxReposIndicator = styled.div`
  color: red;
  margin-left: auto;
  font-size: ${SIZES.normal};
`;

const MaxReposIndicator = () => {
  const license = useSelector(licenseSelector);
  const maxRepos = license?.maxRepos;

  return (
    <StyledMaxReposIndicator>
      Monitoring <b>{maxRepos} repositories</b> - you've reached your plan's
      limit. {` `}
      <Link onClick={openSupportRequest}>Contact Support</Link>
    </StyledMaxReposIndicator>
  );
};

export default MaxReposIndicator;
